<div *ngFor='let reason of this.reason.reasonGroup; let i = index' class='wrapper' fxLayout fxLayoutAlign="space-between center" fxLayoutGap="8px">
  <div
    class="reason"
    fxLayout
    fxLayoutAlign="space-between center"
    [class.empty]="!reasonsTitlesDict[reason.id]"
    [class.inactive]="!isReasonChangeAllowed"
    [matMenuTriggerFor]="isReasonChangeAllowed ? editMenu : undefined"
    [matTooltip]="getFullComment(reason)"
  >
    <span class="reason-title" [style]="'color: ' + (reasonsTitlesDict[reason.id] ? '#000000' : '#7E7E7E')">
      {{ reasonsTitlesDict[reason.id] || '---' }}
    </span>
    <mat-icon *ngIf="isReasonChangeAllowed">arrow_drop_down</mat-icon>
    <mat-menu #editMenu='matMenu'>
      <div mat-menu-item (click)="reasons.at(i)?.setValue(null); reasonsTitlesDict[reason.id] = null; saveComment(reason, comments.at(i)?.value, reasons.at(i)?.value)">
        -- No reason --
      </div>

      <div
        *ngFor="let rs of metricClientReasons"
        mat-menu-item
        (click)="reasons.at(i)?.setValue(rs.id); reasonsTitlesDict[reason.id] = rs.title; saveComment(reason, comments.at(i)?.value, reasons.at(i)?.value)"
      >{{ rs.title }}</div>
    </mat-menu>
  </div>

  <mat-icon (click)="!isSaving ? openReasonDialog() : null" svgIcon="chat-reverse"></mat-icon>
</div>

